import { LINK_ALLOWED_PROTOCOLS } from "@/src/shared/constants";
import { openUrlInNewTab } from "@/src/utils/safeNavigation";

const EXTERNAL_LINK_SELECTOR = "a[href]";

export const registerExternalLinkHandler = () => {
  document.addEventListener("click", externalLink);
};

export const isExternalHref = (href: string): boolean => {
  try {
    const url = new URL(href, window.location.origin);

    if (!LINK_ALLOWED_PROTOCOLS.includes(url.protocol)) {
      return false;
    }

    return url.origin !== window.location.origin;
  } catch {
    return true; // invalid URL → treat as external
  }
};

const getAnchorFromEvent = (event: MouseEvent): HTMLAnchorElement | null => {
  const target = event.target;
  if (!(target instanceof Element)) return null;
  return target.closest<HTMLAnchorElement>(EXTERNAL_LINK_SELECTOR);
};

const isExternalLink = (link: HTMLAnchorElement): boolean => {
  if (link.hasAttribute("target")) return false;
  return isExternalHref(link.href);
};

const externalLink = (event: MouseEvent): void => {
  const link = getAnchorFromEvent(event);
  if (!link || !isExternalLink(link)) return;

  event.preventDefault();
  openUrlInNewTab(link.href);
};
